import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { tap } from 'rxjs/operators';

import * as FaqStoreActions from './faq-store.actions';
import { Store } from '@ngrx/store';
import { ContentService } from 'src/app/shared/services/content.service';
import { CacheService } from 'src/app/shared/services/cache.service';

// const faqGroup = [
//     {
//         title: 'The MARIS database',
//         ids: [70, 71, 72, 73, 74],
//         content: [],
//     },
//     {
//         title: 'Radioactivity basics',
//         ids: [75, 76, 77, 78, 79, 80, 81, 82, 83],
//         content: [],
//     },
//     {
//         title: 'Radioactivity in the marine environment',
//         ids: [84, 85, 86],
//         content: [],
//     },
// ];

@Injectable()
export class FaqStoreEffects {
    constructor(private actions$: Actions, private store: Store, private contentService: ContentService, private cacheService: CacheService) {}

    loadFaqStores$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(FaqStoreActions.loadFaqStores),
                tap(() => {
                    if (!this.cacheService.getCMSData().faqs.content || !this.cacheService.enableCMSStorage) {
                        this.contentService.getFAQs().subscribe((data) => {
                            let tempStorage = this.cacheService.getCMSData();

                            const faqs = data;

                            /*
                                Select all distinct contentCategory from faqs

                                contentCategory is group title
                                each group title has a list of ids of faqs 
                            */
                            const contentCategories = [...new Set(faqs.map((item) => item.contentCategory))];

                            // group faqs by contentCategory
                            let faqGroup = contentCategories.map((item) => {
                                return {
                                    title: item,
                                    content: faqs.filter((faq) => faq.contentCategory === item),
                                };
                            });

                            tempStorage.faqs = { content: [...faqGroup] };
                            this.cacheService.setCMSData(tempStorage);

                            this.store.dispatch(
                                FaqStoreActions.loadFaqStoresSuccess({
                                    data: tempStorage.faqs.content,
                                })
                            );
                        });
                    } else {
                        this.store.dispatch(
                            FaqStoreActions.loadFaqStoresSuccess({
                                data: this.cacheService.getCMSData().faqs.content,
                            })
                        );
                    }
                })
            );
        },
        { dispatch: false }
    );
}
